import { SMILE9_API_ENDPOINT } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UtilService } from '../util/util.service';
import { CheckNullExpectType } from '../enums-master';
import { IIntroQuestionnaire } from './intro-questionnaire-if';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class IntroQuestionnaireService {
  private static controlerName = 'api/Questionnaire';

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
  ) { }

  public static openModal(): void {
    const postFlag: string = localStorage.getItem('[IntroQuestionnaire]isAnswered');
    if (postFlag !== 'true') {
      $('#IntroQuestionnaireModal').modal('show');
    }
  }

  public static closeModel(): void {
    $('#IntroQuestionnaireModal').modal('hide');
  }

  /** アンケート回答 */
  public answerQuestionnaire(data: IIntroQuestionnaire.CreateModel) {
    const httpBody: IIntroQuestionnaire.CreateModel = {
      answer_int: this.utilServ.uType.checkNull(data.answer_int, CheckNullExpectType.number),
      answer_string: this.utilServ.uType.checkNull(data.answer_string, CheckNullExpectType.string),
    };
    Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());
    this.http.request('post', `${SMILE9_API_ENDPOINT}${IntroQuestionnaireService.controlerName}`, { body: httpBody })
      .subscribe(
        result => {
          localStorage.setItem('[IntroQuestionnaire]isAnswered', 'true');
        },
        err => {
          console.error(err);
        }
      );
  }
}
